import { Row } from '../Row';

export const Header: React.FC = () => (
	<div className="cart-header">
		<Row left="Item" right="Price" />
	</div>
);
